import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedColors: [],
  selectedClarities: [],
  selectedCell: null, // color clarity detailed table cell
  selectedColorGroup: [], // Array for grouped color selections
  selectedClarityGroup: [], // Array for grouped clarity selections
  selectedGroupedCell: null,
  selectionMode: 'individual'
};

const colorClaritySlice = createSlice({
  name: 'colorClarity',
  initialState,
  reducers: {
    setSelectedCell: (state, action) => {
      state.selectionMode = 'individual';
      state.selectedCell = action.payload;
      state.selectedGroupedCell = null;
      // Update both individual and group selections
      state.selectedColors = Array.isArray(action.payload.color) ? action.payload.color : [action.payload.color];
      state.selectedClarities = Array.isArray(action.payload.clarity) ?  action.payload.clarity: [action.payload.clarity];
      state.selectedColorGroup = [];
      state.selectedClarityGroup = [];
    },
    setSelectedGroupedCell: (state, action) => {
      state.selectionMode = 'grouped';
      state.selectedGroupedCell = action.payload;
      state.selectedCell = null;
      // Group selections should be handled by their respective actions
      state.selectedColors = [];
      state.selectedClarities = [];
    },
    setSelectedColors: (state, action) => {
      if (state.selectionMode === 'individual') {
        state.selectedColors = Array.isArray(action.payload) ? action.payload : [];
        state.selectedColorGroup = [];
      }
    },
    setSelectedClarities: (state, action) => {
      if (state.selectionMode === 'individual') {
        state.selectedClarities = Array.isArray(action.payload) ? action.payload : [];
        state.selectedClarityGroup = [];
      }
    },
    setSelectedColorGroup: (state, action) => {
      if (state.selectionMode === 'grouped') {
        state.selectedColorGroup = Array.isArray(action.payload) ? action.payload : [];
        state.selectedColors = []; // Update individual selections too
      }
    },
    setSelectedClarityGroup: (state, action) => {
      if (state.selectionMode === 'grouped') {
        state.selectedClarityGroup = Array.isArray(action.payload) ? action.payload : [];
        state.selectedClarities = []; // Update individual selections too
      }
    }
  }
});

export const {
  setSelectedCell,
  setSelectedGroupedCell,
  setSelectedColors,
  setSelectedClarities,
  setSelectedColorGroup,
  setSelectedClarityGroup
} = colorClaritySlice.actions;

export default colorClaritySlice.reducer;